import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { rem } from 'approot/shared/style';
import { grey7, grey8 } from 'approot/shared/styles/colours.style';
import {
  anchorLinkBase,
  fontSize14,
} from 'approot/shared/styles/typography.style';
import { spacing8, spacing16 } from 'approot/shared/styles/spacing.style';
import IconNavArrow from 'approot/shared/inline-svg/navigation/icon-nav-arrow';

export const BreadcrumbArrow = styled(IconNavArrow).attrs({
  width: 12,
  height: 12,
  rotate: -90,
})`
  margin: 0 ${rem(spacing8)};
  transform-origin: 60% 60%;
  width: ${rem(12)};
`;

export const BreadcrumbArrowReverse = styled(BreadcrumbArrow).attrs({
  rotate: 90,
})`
  margin: 0;
  transform-origin: ${rem(2)} ${rem(3)};
`;

export const Breadcrumbs = styled.nav`
  margin-bottom: ${rem(spacing16)};

  ul,
  li {
    margin: 0;
    padding: 0;
  }

  li {
    display: inline;
  }
`;

export const BreadcrumbLink = styled(Link)`
  ${anchorLinkBase};
  color: ${grey8};
  display: inline-block;
  font-size: ${rem(fontSize14)};
  padding: ${rem(1)};
`;

export const Breadcrumb = styled.span`
  color: ${grey7};
  display: inline-block;
  font-size: ${rem(fontSize14)};
  padding: ${rem(1)};
`;
